const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      background: theme.colors[4],
      color: theme.colors[1],
      paddingTop: (props) => props.headerHeight,
    },
    wrapper: {
      extend: theme.wrapper,
    },
    description: {
      marginTop: 75,
    },
    services: {
      marginTop: 120,
      '& .serviceItem__root': {
        width: '90%',
      },
      '& .revealGrid__root': {
        '& > *:not(:last-child)': {
          marginBottom: 50,
        },
        '& > *:nth-child(even)': {
          marginLeft: 'auto',
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    services: {
      '& .serviceItem__root': {
        width: '100%',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    description: {
      marginTop: 60,
    },
    services: {
      marginTop: 60,
    },
  }

  return output
}

export default style
